export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8444.1e6e2333.jpg";